import "../styles/globals.css";
import "../styles/index.css";
import "../styles/hero.css";
// import "../styles/shapes.css";

function MyApp({ Component, pageProps }) {
  return <Component {...pageProps} />;
}

export default MyApp;
